import { connectHits } from 'instantsearch.js/es/connectors'
import hitPublication from './hitPublication'
import hitNews from './hitNews'

const renderHits = (renderOptions, isFirstRender) => {
  const { hits, widgetParams } = renderOptions

  if (hits.length !== 0) {
    widgetParams.container.innerHTML = '<ul class="row"></ul>'

    hits.forEach((hit) => {
      const li = document.createElement('li')

      if (widgetParams.type === 'publication') {
        li.className = 'list-grid__item col-12 md-col-6 lg-col-4 flex'
        li.innerHTML = hitPublication(hit)
      } else if (widgetParams.type === 'news') {
        li.className = 'list-grid__item col-12 md-col-6 lg-col-4 flex'
        li.innerHTML = hitNews(hit)
      }

      widgetParams.container.querySelector('ul').appendChild(li)
    })
  } else {
    widgetParams.container.innerHTML = config.trads['search.no-result']
  }
}

const customHits = connectHits(renderHits)

export default customHits
